import React, { Component } from 'react';
import WidgetTitle from './WidgetTitle';
import axios from 'axios';
import qs from 'qs'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import HighchartsReact from 'highcharts-react-official'
import Config from './Configs/criteria.json';
import cookie from 'react-cookies';
import Tooltip from 'react-tooltip-lite';
import './Analysis.css';
import './Tooltip.css';
import Collapsible from 'react-collapsible';
import refinitivlogo from './img/refinitiv.png';
import pdficon from './img/pdf_icon.svg';
import pdficond from './img/pdf_icon_d.svg';
import pdficonh from './img/pdf_icon_h.svg';

HighchartsMore(Highcharts)

const SCOREBAR_FULL_WIDTH = 170;

const options = {
    "title": {
        "text": ""
    },
    "subtitle": {
        "text": " "
    },
    "exporting": {
        "enabled": false
    },
    "chart": {
        "type": "area",
        "polar": true,
        "backgroundColor": "transparent",
        "width": 315,
        "height": 210
    },
    pane: {
        size: '80%'
    },
    xAxis: {
        categories: ['<span>財務健全性</span>', '<span>収益性</span>', '<span>割安性</span>', '<span>安定性</span>', '<span>株価</span><br><span>モメンタム</span>'],
        tickmarkPlacement: 'on',
        lineWidth: 0,
        labels: {
            align: 'center',
            distance: 18,
            y: 5
        }
    },
    yAxis: {
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0,
        max: 10,
        labels: {
            formatter: function () {
                var value = this.axis.defaultLabelFormatter.call(this);
                return (this.value === 0 ? ' ' : value);  //hides 0 value
            }
        }
    },
    "plotOptions": {
        "series": {
            "animation": false,
            "dataLabels": {},
            events: {
                legendItemClick: function () {
                    return false;
                }
            }, "fillOpacity": 0.3
        }
    },
    "credits": {
        "enabled": false
    },
    "lang": {},
    "tooltip": {},
    "legend": {
        "reversed": true
    },
    "colors": [
        "#72A3DD",
        "#DE73A6",
        "#90ed7d",
        "#f7a35c",
        "#8085e9",
        "#f15c80",
        "#e4d354",
        "#2b908f",
        "#f45b5b",
        "#91e8e1"
    ]
};
const { detect } = require('detect-browser');
const browser = detect();
let cancel;
let cookiePath = "/"
export default class Analysis extends Component {
    constructor(props) {
        super(props);

        if (browser) {
            if (browser.name === "ie" && browser.os === "Windows 7") {
                cookiePath = "/"
            }
            else {
                cookiePath = process.env.REACT_APP_ROUTER_BASE || "/"
            }
            //   console.log(cookiePath)
        }
        this.token = qs.parse(props.location.search, { ignoreQueryPrefix: true }).token;
        this.sym = qs.parse(props.location.search, { ignoreQueryPrefix: true }).sym;

        localStorage.setItem('SBI_JP_SCR_TOKEN', this.token)

        this.state = {
            stockname: "",
            tse33_name: "",
            co_score: [],
            ind_score: [],
            options,
            indscoregroup: "",
            indscoresector: "",
            indscoretable: [],
            target_price: "",
            rise_potential: "",
            rise_pct: "",
            num_of_est: "",
            last_update: "",
            tpchart: "",
            compchart: "",
            savedListOpen: true,
            srplus_link: "",
            vid:"",
            pdf_icon: require('./img/pdf_icon_d.svg'),
            video_icon: require('./img/video_icon.svg')
        };
        let savedListOpen_local = localStorage.getItem('SBI_JP_SCR_OL');
        let savedListOpen = cookie.load("OL");
        if (!savedListOpen_local) {
            if (!savedListOpen) {
                this.setState({ savedListOpen: true });
                savedListOpen = "true";
                localStorage.setItem('SBI_JP_SCR_OL', "true");
                // document.cookie = "OL=true; expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath + ";SameSite=None; Secure";
                // cookie.save("OL", true, { path: process.env.REACT_APP_ROUTER_BASE || "/", maxAge: Config.myscreener.maxAge });
            } else {
                // console.log("111:"+savedListOpen);
                this.setState({ savedListOpen: savedListOpen === "true" ? true : false });
            }
        } else {
            this.setState({ savedListOpen: savedListOpen_local === "true" ? true : false });
        }

    }
    calcStockScoreBarWidth = (type) => {
        if (this.state.co_score[type]) {
            return parseFloat(this.state.co_score[type]) * SCOREBAR_FULL_WIDTH / 10;
        } else {
            return 0;
        }
    }
    calcIndustryScoreBarWidth = (type) => {
        if (this.state.ind_score[type]) {
            return parseFloat(this.state.ind_score[type]) * SCOREBAR_FULL_WIDTH / 10;
        } else {
            return 0;
        }
    }
    calcStockScorePos = (type) => {
        if (this.state.co_score[type]) {
            return parseFloat(this.state.co_score[type]) * SCOREBAR_FULL_WIDTH / 10 + 15 + 5;
        } else {
            return 15;
        }
    }
    calcIndustryScorePos = (type) => {
        if (this.state.ind_score[type]) {
            return parseFloat(this.state.ind_score[type]) * SCOREBAR_FULL_WIDTH / 10 + 15 + 5;
        } else {
            return 15;
        }
    }
    formatNumber = (val, dp) => {
        if (val) {
            if (typeof val !== 'number') {
                val = parseFloat(val.replace(/,/g, ''));
                if (isNaN(val)) {
                    return '-';
                }
            }
            if (dp) {
                val = new Intl.NumberFormat('en-GB', {
                    minimumFractionDigits: dp,
                    maximumFractionDigits: dp
                }).format(val);
            } else {
                val = new Intl.NumberFormat('en-GB').format(val);
            }
            return val;
        } else {
            return '-';
        }
    }
    formatPercentage = (val) => {
        if (val) {
            if (typeof val !== 'number') {
                val = parseFloat(val.replace(/,/g, ''));
            }
            return (val > 0 ? "+" : "") + new Intl.NumberFormat('en-GB', {
                style: 'percent',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(val);
        } else {
            return '-'
        }
    }
    formatDate = (d) => {
        if (d) {
            return d.toLocaleString("en-us", { year: 'numeric' }) + '/' + d.toLocaleString("en-us", { month: '2-digit' }) + '/' + d.toLocaleString("en-us", { day: '2-digit' });
        } else {
            return '-';
        }
    }
    getData = () => {
        axios.get("data/analysisinfo", {
            params: {
                ric: this.sym,
                token: this.token
            }
        })
            .then(
                (result) => {
                    let score = result.data.score;
                    let co_score = [];
                    let ind_score = [];
                    for (let i = 0; i < score.length; i++) {
                        if (score[i].type === "CO_SCORE") {
                            co_score["analyst_score"] = this.formatNumber(score[i].analyst_score, 1);
                            co_score["avg_score"] = this.formatNumber(score[i].avg_score, 1);
                            co_score["fund_score"] = this.formatNumber(score[i].fund_score, 1);
                            co_score["rc_score"] = this.formatNumber(score[i].rc_score, 1);
                            co_score["risk_score"] = this.formatNumber(score[i].risk_score, 1);
                            co_score["tech_score"] = this.formatNumber(score[i].tech_score, 1);
                        } else if (score[i].type === "IND_SCORE") {
                            ind_score["analyst_score"] = this.formatNumber(score[i].analyst_score, 1);
                            ind_score["avg_score"] = this.formatNumber(score[i].avg_score, 1);
                            ind_score["fund_score"] = this.formatNumber(score[i].fund_score, 1);
                            ind_score["rc_score"] = this.formatNumber(score[i].rc_score, 1);
                            ind_score["risk_score"] = this.formatNumber(score[i].risk_score, 1);
                            ind_score["tech_score"] = this.formatNumber(score[i].tech_score, 1);
                        }
                    }
                    let indscoregroup = this.formatNumber(result.data.asset.indGroupScore, 1);
                    let indscoresector = this.formatNumber(result.data.asset.indSectorScore, 1);

                    let indscoretable = [];
                    for (let i = 0; i < 6; i++) {
                        let column = [];
                        for (let j = 1; j < result.data.indScoreAvg.length + 1; j++) {
                            if (i === 0) {
                                column[j] = <React.Fragment><div className="name">{result.data.indScoreAvg[j - 1].stockName}</div><div className="code">({result.data.indScoreAvg[j - 1].ric})</div></React.Fragment>;
                            } else if (i === 1) {
                                column[j] = result.data.indScoreAvg[j - 1].now;
                            } else if (i === 2) {
                                column[j] = result.data.indScoreAvg[j - 1]["2w"];
                            } else if (i === 3) {
                                column[j] = result.data.indScoreAvg[j - 1]["1m"];
                            } else if (i === 4) {
                                column[j] = result.data.indScoreAvg[j - 1]["3m"];
                            } else if (i === 5) {
                                column[j] = result.data.indScoreAvg[j - 1]["6m"];
                            }
                        }
                        indscoretable[i] = column;
                    }
                    indscoretable[1][0] = "現在";
                    indscoretable[2][0] = "1週間前";
                    indscoretable[3][0] = "1ヶ月前";
                    indscoretable[4][0] = "3ヶ月前";
                    indscoretable[5][0] = "6ヶ月前";

                    let target_price = result.data.targetprice.target_price;
                    let rise_potential = result.data.targetprice.rise_potential;
                    let rise_pct = result.data.targetprice.rise_pct;
                    let num_of_est = result.data.targetprice.num_of_est;
                    let last_update = result.data.targetprice.last_update;
                    if (last_update) {
                        let d = new Date(last_update);
                        last_update = this.formatDate(d);
                    } else {
                        last_update = "-";
                    }
                    let tpchart = result.data.targetprice.tpchart;
                    let compchart = result.data.asset.chart;
                    let stockname = result.data.asset.stockName;
                    let tse33_name = result.data.asset.tse33_name;
                    let businessName = result.data.asset.businessName;
                    let sectorName = result.data.asset.sectorName;
                    let industryName = result.data.asset.industryName;
                    let srplus_link = result.data.asset.srplus_link;
                    let vid = result.data.asset.vid;
                    this.setState({ stockname, tse33_name, co_score, ind_score, indscoregroup, indscoresector, indscoretable, target_price, rise_potential, rise_pct, num_of_est, last_update, tpchart, compchart, businessName, sectorName, industryName, srplus_link , vid});

                    let series = {
                        series: [{
                            name: result.data.asset.industryName,
                            data: [parseFloat(ind_score["fund_score"] === "-" ? 0 : ind_score["fund_score"]), parseFloat(ind_score["analyst_score"] === "-" ? 0 : ind_score["analyst_score"]), parseFloat(ind_score["rc_score"] === "-" ? 0 : ind_score["rc_score"]), parseFloat(ind_score["risk_score"] === "-" ? 0 : ind_score["risk_score"]), parseFloat(ind_score["tech_score"] === "-" ? 0 : ind_score["tech_score"])],
                            pointPlacement: 'on'
                        }, {
                            name: result.data.asset.stockName,
                            data: [parseFloat(co_score["fund_score"] === "-" ? 0 : co_score["fund_score"]), parseFloat(co_score["analyst_score"] === "-" ? 0 : co_score["analyst_score"]), parseFloat(co_score["rc_score"] === "-" ? 0 : co_score["rc_score"]), parseFloat(co_score["risk_score"] === "-" ? 0 : co_score["risk_score"]), parseFloat(co_score["tech_score"] === "-" ? 0 : co_score["tech_score"])],
                            pointPlacement: 'on'
                        }]
                    };
                    this.setState({ options: series });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                }
            )
    }
    genIndScoreTable = () => {
        let result = [];
        for (let i = 0; i < this.state.indscoretable.length; i++) {
            let td = [];
            for (let j = 0; j < 6; j++) {
                let cls = "topic";
                if (this.state.indscoretable[i]) {
                    if (j !== 0) {
                        cls = "content";
                    }
                    if (i === 0) {
                        td.push(<th className={cls}>{this.state.indscoretable[i][j]}</th>)
                    } else {
                        td.push(<td className={cls}>{this.state.indscoretable[i][j]}</td>)
                    }
                } else {
                    td.push(<th className={cls}></th>)
                }


            }
            result.push(<tr>{td}</tr>);
        }
        return result;
    }
    componentDidMount() {
        if (this.sym.length < 9) {
            this.getData();

            let savedListOpen_local = localStorage.getItem('SBI_JP_SCR_OL');
            let savedListOpen = cookie.load("OL");
            if (!savedListOpen_local) {
                if (!savedListOpen) {
                    this.setState({ savedListOpen: true });
                    savedListOpen = "true";
                    localStorage.setItem('SBI_JP_SCR_OL', "true");
                    // document.cookie = "OL=true; expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath + ";SameSite=None; Secure";
                    // cookie.save("OL", true, { path: process.env.REACT_APP_ROUTER_BASE || "/", maxAge: Config.myscreener.maxAge });
                } else {
                    localStorage.setItem('SBI_JP_SCR_OL', savedListOpen)
                    // console.log("111:"+savedListOpen);
                    this.setState({ savedListOpen: savedListOpen === "true" ? true : false });
                }
            } else {
                this.setState({ savedListOpen: savedListOpen_local === "true" ? true : false });
            }
        }
    }
    checkOpen = () => {
        localStorage.setItem('SBI_JP_SCR_OL', "true");
        // document.cookie = "OL=true; expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath + ";SameSite=None; Secure";
        // cookie.save("OL", true, { path: process.env.REACT_APP_ROUTER_BASE || "/", maxAge: Config.myscreener.maxAge });
        this.setState({ savedListOpen: true });
    }
    checkClose = () => {
        localStorage.setItem('SBI_JP_SCR_OL', "false");
        // document.cookie = "OL=false; expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath + ";SameSite=None; Secure";
        // cookie.save("OL", false, { path: process.env.REACT_APP_ROUTER_BASE || "/", maxAge: Config.myscreener.maxAge });
        this.setState({ savedListOpen: false });
    }
    getCookieExpiresDate = () => {
        const expires = new Date()
        expires.setTime((Date.now() + 1000 * 60 * 60 * 24 * 30))
        return expires;
    }
    render() {
        return (
            <div className="Analysis">
                <div className="pdfdiv">
                    <WidgetTitle content="企業スコア" />
                    {this.state.srplus_link &&
                        <div onClick={() => { fetch("/sbiscrapi/srpluslog?app=pc&ric=" + this.sym) }}>
                            <a className="pdflinkbtn" rel="noopener noreferrer" target="_blank" href={this.state.srplus_link}>
                                <img
                                    src={this.state.pdf_icon}
                                    width="120"
                                    alt="srplus"
                                    onMouseOver={() => { this.setState({ pdf_icon: require('./img/pdf_icon_h.svg') }) }}
                                    onMouseOut={() => { this.setState({ pdf_icon: require('./img/pdf_icon_d.svg') }) }} />
                            </a></div>}
                    {this.state.vid &&
                        <div>
                            <a className="videolinkbtn" rel="noopener noreferrer" target="_blank" href={"/sbivideo/video?vid="+this.state.vid+"&sbi_setting=2000000&mode=pc&token="+this.token}>
                                <img
                                    src={this.state.video_icon}
                                    height="22"
                                    alt="srplus"
                                    onMouseOver={() => { this.setState({ video_icon: require('./img/video_icon_h.png') }) }}
                                    onMouseOut={() => { this.setState({ video_icon: require('./img/video_icon.svg') }) }}
                                    />
                            </a></div>}

                </div>
                <div className="companyscorebox">
                    <div>
                        <table className="companyscoretable scoresummary">
                            <tbody>
                                <tr>
                                    <td className="th">
                                        企業スコア総合 <div className="info"><Tooltip direction="right" arrow={false} content={Config.criteria.score[0].tooltip}>?</Tooltip></div>

                                    </td>
                                    <td className="avg_socre_td"><span className="avg_socre_l">{this.state.co_score["avg_score"]}</span> <span className="avg_socre_r">(業界平均値{this.state.ind_score["avg_score"]})</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="companyscoretable">
                            <tbody>
                                <tr>
                                    <td className="th">財務健全性<div className="info"><Tooltip direction="right" arrow={false} content={Config.criteria.score[1].tooltip}>?</Tooltip></div></td>
                                    <td className="scorebar"><div className="stockbar" style={{ width: this.calcStockScoreBarWidth("fund_score") }}></div><div className="sectorbar" style={{ width: this.calcIndustryScoreBarWidth("fund_score") }}></div><div className="stockscore" style={{ left: this.calcStockScorePos("fund_score") }}>{this.state.co_score["fund_score"]}</div><div className="sectorscore" style={{ left: this.calcIndustryScorePos("fund_score") }}>({this.state.ind_score["fund_score"]})</div></td>
                                </tr>
                                <tr>
                                    <td className="th">収益性<div className="info"><Tooltip direction="right" arrow={false} content={Config.criteria.score[2].tooltip}>?</Tooltip></div></td>
                                    <td className="scorebar"><div className="stockbar" style={{ width: this.calcStockScoreBarWidth("analyst_score") }}></div><div className="sectorbar" style={{ width: this.calcIndustryScoreBarWidth("analyst_score") }}></div><div className="stockscore" style={{ left: this.calcStockScorePos("analyst_score") }}>{this.state.co_score["analyst_score"]}</div><div className="sectorscore" style={{ left: this.calcIndustryScorePos("analyst_score") }}>({this.state.ind_score["analyst_score"]})</div></td>
                                </tr>
                                <tr>
                                    <td className="th">割安性<div className="info"><Tooltip direction="right" arrow={false} content={Config.criteria.score[3].tooltip}>?</Tooltip></div></td>
                                    <td className="scorebar"><div className="stockbar" style={{ width: this.calcStockScoreBarWidth("rc_score") }}></div><div className="sectorbar" style={{ width: this.calcIndustryScoreBarWidth("rc_score") }}></div><div className="stockscore" style={{ left: this.calcStockScorePos("rc_score") }}>{this.state.co_score["rc_score"]}</div><div className="sectorscore" style={{ left: this.calcIndustryScorePos("rc_score") }}>({this.state.ind_score["rc_score"]})</div></td>
                                </tr>
                                <tr>
                                    <td className="th">安定性<div className="info"><Tooltip direction="right" arrow={false} content={Config.criteria.score[4].tooltip}>?</Tooltip></div></td>
                                    <td className="scorebar"><div className="stockbar" style={{ width: this.calcStockScoreBarWidth("risk_score") }}></div><div className="sectorbar" style={{ width: this.calcIndustryScoreBarWidth("risk_score") }}></div><div className="stockscore" style={{ left: this.calcStockScorePos("risk_score") }}>{this.state.co_score["risk_score"]}</div><div className="sectorscore" style={{ left: this.calcIndustryScorePos("risk_score") }}>({this.state.ind_score["risk_score"]})</div></td>
                                </tr>
                                <tr>
                                    <td className="th">株価モメンタム<div className="info"><Tooltip direction="right" arrow={false} content={Config.criteria.score[5].tooltip}>?</Tooltip></div></td>
                                    <td className="scorebar"><div className="stockbar" style={{ width: this.calcStockScoreBarWidth("tech_score") }}></div><div className="sectorbar" style={{ width: this.calcIndustryScoreBarWidth("tech_score") }}></div><div className="stockscore" style={{ left: this.calcStockScorePos("tech_score") }}>{this.state.co_score["tech_score"]}</div><div className="sectorscore" style={{ left: this.calcIndustryScorePos("tech_score") }}>({this.state.ind_score["tech_score"]})</div></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="spiderchart">
                        <HighchartsReact highcharts={Highcharts} options={this.state.options} />
                    </div>
                </div>

                <Collapsible handleTriggerClick={() => { if (!this.state.savedListOpen) { this.checkOpen() } else { this.checkClose() } }} onClose={this.checkClose} onOpen={this.checkOpen} classParentString="innerCollapsible" trigger={<div><WidgetTitle content="同業種スコア平均" /><span className="box" /></div>} open={true}>
                    <div className="sectorscorebox">
                        <div className="indscore">
                            <span className="indscoresector">{this.state.sectorName}：{this.state.indscoresector}</span>&nbsp;{this.state.businessName && <span className="indscoregroup">{this.state.businessName}：{this.state.indscoregroup}</span>}
                        </div>
                        <table className="indscoretable">
                            <tbody>
                                {this.genIndScoreTable()}
                            </tbody>
                        </table>
                    </div>
                </Collapsible>


                <div className="stockpricebox">
                    <div className="targetpricebox">
                        <WidgetTitle content="目標株価" />
                        <div>
                            <table className="targetPriceTable">
                                <tbody>
                                    <tr className="pricerow">
                                        <td className="td" colSpan="2"><span className="targetPrice">{this.formatNumber(this.state.target_price, 1)}</span><span className="targetPriceY"> 円</span></td>
                                        <td className="td b3">かい離</td>
                                        <td className={(this.state.rise_potential != null && this.state.rise_potential.indexOf("+") > -1) ? "td b4 positive" : ((this.state.rise_potential != null && this.state.rise_potential.indexOf("-") > -1) ? "td b4 negative" : "td b4")}>{this.state.rise_potential === null ? "-" : this.state.rise_potential}<br />({this.formatPercentage(this.state.rise_pct / 100)})</td>
                                    </tr>
                                    <tr>
                                        <td className="td c1">予測数</td>
                                        <td className="td c2">{this.state.num_of_est === null ? "-" : this.state.num_of_est}</td>
                                        <td className="td c3">更新日</td>
                                        <td className="td c4">{this.state.last_update}</td>
                                    </tr>
                                    <tr>
                                        <td align="center" colSpan="4" className="tpchartcontainer">
                                            <div className="tpchart">
                                                {this.state.tpchart &&
                                                    <img src={(process.env.REACT_APP_DATA_API_DOMAIN || "/sbiscrapi/") + this.state.tpchart + "&token=" + localStorage.getItem('SBI_JP_SCR_TOKEN')} alt="" />
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="comparison">
                        <WidgetTitle content="過去1年間の株価比較" />
                        <div className="comparisonbox">
                            <div className="title1">週足</div>
                            <div className="title2">(1年前=100とする)</div>
                            <div className="compchartcontainer">
                                <img src={(process.env.REACT_APP_DATA_API_DOMAIN || "/sbiscrapi/") + this.state.compchart + "&token=" + localStorage.getItem('SBI_JP_SCR_TOKEN')} alt="" width="285px" height="181px" />
                            </div>
                            <div class="legend">
                                <div className="stockbox"></div>
                                <div className="text">{this.state.stockname}</div>
                                <div className="sectorbox"></div>
                                <div className="text">{this.state.tse33_name}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <a className='refinitivlogo' href="disclaimer" target="_blank">
                    <img src={refinitivlogo} width="150" alt="Refinitiv" /></a>
            </div>
        )
    };
}